{
  "shop.title": "Butikk",
  "shop.subtitle": "Bestill produkter fra ColorGlo HQ.",
  "shop.search": "Søk etter produkt eller artikkelnummer",
  "shop.category.all": "Alle",
  "shop.empty": "Ingen produkter samsvarer med søket.",
  "shop.error": "Butikken kunne ikke lastes.",
  "shop.retry": "Prøv igjen",
  "shop.sizes.one": "{count} størrelse",
  "shop.sizes.other": "{count} størrelser",
  "shop.no_image": "Ingen bilde",
  "shop.back": "Tilbake til butikken",
  "shop.product.not_found": "Produktet finnes ikke lenger i butikken.",
  "shop.product.variants": "Størrelser",
  "shop.product.sku": "Art.nr",
  "shop.product.size": "Størrelse",
  "shop.product.status": "Status",
  "shop.product.size_missing": "Ikke oppgitt",
  "shop.product.orderable": "Kan bestilles",
  "shop.product.unavailable": "Kan ikke bestilles",
  "shop.product.video": "Se film",
  "shop.product.content": "Produktinformasjon",
  "shop.cart.title": "Handlekurv",
  "shop.cart.add": "Legg i handlekurven",
  "shop.cart.added": "{name} ligger i handlekurven.",
  "shop.cart.empty": "Handlekurven er tom.",
  "shop.cart.browse": "Til butikken",
  "shop.cart.qty": "Antall",
  "shop.cart.decrease": "Reduser antall",
  "shop.cart.increase": "Øk antall",
  "shop.cart.remove": "Fjern",
  "shop.cart.unavailable": "Kan ikke lenger bestilles og sendes ikke med.",
  "shop.cart.notes": "Melding til HQ",
  "shop.cart.notes_hint": "Valgfritt, for eksempel ønsket leveringsdag.",
  "shop.cart.submit": "Send bestilling",
  "shop.cart.sending": "Sender …",
  "shop.cart.sent": "Bestillingen er sendt til HQ.",
  "shop.cart.failed": "Bestillingen kunne ikke sendes. Prøv igjen.",
  "shop.cart.review_note": "HQ går gjennom bestillingen og kan redusere antall hvis noe mangler på lager.",
  "shop.orders.title": "Mine bestillinger",
  "shop.orders.empty": "Ingen bestillinger ennå.",
  "shop.orders.number": "Ordre {number}",
  "shop.orders.date": "Dato",
  "shop.orders.status": "Status",
  "shop.orders.items.one": "{count} artikkel",
  "shop.orders.items.other": "{count} artikler",
  "shop.orders.back": "Alle bestillinger",
  "shop.orders.error": "Bestillingene kunne ikke lastes.",
  "shop.order.not_found": "Bestillingen ble ikke funnet.",
  "shop.order.lines": "Artikler",
  "shop.order.product": "Produkt",
  "shop.order.ordered": "Bestilt",
  "shop.order.approved_qty": "Godkjent",
  "shop.order.delivery": "Leveringsadresse",
  "shop.order.notes": "Melding fra verkstedet",
  "shop.order.history": "Historikk",
  "shop.order.cancel": "Avbryt bestillingen",
  "shop.order.cancel_confirm": "Avbryte ordre {number}? Det kan ikke angres.",
  "shop.order.keep": "Behold",
  "shop.order.cancelled_toast": "Bestillingen er avbrutt.",
  "shop.order.placed_by": "Lagt inn av {name}",
  "shop.order.adjusted": "Justert av HQ",
  "shop.status.submitted": "Venter på HQ",
  "shop.status.approved": "Godkjent",
  "shop.status.rejected": "Avvist",
  "shop.status.shipped": "Sendt",
  "shop.status.cancelled": "Avbrutt",
  "shop.event.submitted": "Bestillingen ble sendt",
  "shop.event.approved": "HQ godkjente bestillingen",
  "shop.event.rejected": "HQ avviste bestillingen",
  "shop.event.shipped": "HQ sendte bestillingen",
  "shop.event.cancelled": "Bestillingen ble avbrutt",
  "shop.hq.title": "Bestillinger",
  "shop.hq.subtitle": "Bestillinger fra verkstedene.",
  "shop.hq.all": "Alle",
  "shop.hq.workshop": "Verksted",
  "shop.hq.empty": "Ingen bestillinger her.",
  "shop.hq.decision": "Beslutning",
  "shop.hq.approve": "Godkjenn",
  "shop.hq.approve_hint": "Reduser antallet eller sett 0 for det som mangler på lager.",
  "shop.hq.note": "Melding til verkstedet",
  "shop.hq.reject": "Avvis",
  "shop.hq.reject_reason": "Begrunnelse",
  "shop.hq.reject_hint": "Verkstedet ser begrunnelsen.",
  "shop.hq.approved_toast": "Bestillingen er godkjent.",
  "shop.hq.rejected_toast": "Bestillingen er avvist.",
  "shop.hq.nothing_left": "Minst én linje må være igjen. Avvis bestillingen i stedet.",
  "shop.hq.failed": "Beslutningen kunne ikke lagres. Prøv igjen.",
  "shop.orders.order": "Ordre",
  "shop.invoice.title": "Følgeseddel",
  "shop.invoice.invoice_number": "Følgeseddelnummer",
  "shop.invoice.invoice_date": "Dato",
  "shop.invoice.order_number": "Ordrenummer",
  "shop.invoice.order_date": "Ordredato",
  "shop.invoice.ship_date": "Sendt",
  "shop.invoice.seller": "Fra",
  "shop.invoice.buyer": "Til",
  "shop.invoice.org_nr": "Org.nr",
  "shop.invoice.vat_nr": "MVA-nr",
  "shop.invoice.sku": "Art.nr",
  "shop.invoice.product": "Produkt",
  "shop.invoice.qty": "Antall",
  "shop.invoice.download": "Last ned følgeseddel {number}",
  "shop.email.order_placed.subject": "Ny bestilling {number} fra {workshop}",
  "shop.email.order_placed.heading": "Ny bestilling fra {workshop}",
  "shop.email.order_placed.body": "{workshop} har sendt ordre {number}. Den venter på deres beslutning.",
  "shop.email.order_approved.subject": "Ordre {number} er godkjent",
  "shop.email.order_approved.heading": "Bestillingen deres er godkjent",
  "shop.email.order_approved.body": "HQ har godkjent ordre {number}. Vi gir beskjed når den sendes.",
  "shop.email.order_rejected.subject": "Ordre {number} er avvist",
  "shop.email.order_rejected.heading": "Bestillingen deres kunne ikke tas imot",
  "shop.email.order_rejected.body": "HQ har dessverre avvist ordre {number}.",
  "shop.email.order_shipped.subject": "Ordre {number} er sendt – følgeseddel {invoice}",
  "shop.email.order_shipped.heading": "Bestillingen deres er på vei",
  "shop.email.order_shipped.body": "Ordre {number} er sendt. Følgeseddel {invoice} er vedlagt.",
  "shop.email.adjusted": "HQ har justert antallet på én eller flere linjer.",
  "shop.email.note": "Melding fra HQ: {note}",
  "shop.email.reason": "Begrunnelse: {note}",
  "shop.email.cta": "Vis bestillingen",
  "shop.hq.ship": "Merk som sendt",
  "shop.hq.ship_confirm": "En leveranse registreres for ordre {number}. En følgeseddel for det som sendes opprettes og sendes på e-post til verkstedet. Det kan ikke angres.",
  "shop.hq.shipped_toast": "Ordren er sendt og følgeseddelen er opprettet.",
  "shop.order.invoice": "Følgeseddel {number}, {date}",
  "shop.hq.not_now": "Ikke nå",
  "shop.admin.title": "Produkter",
  "shop.admin.subtitle": "Butikkens sortiment og hva som kan bestilles.",
  "shop.admin.search": "Søk etter produkt eller artikkelnummer",
  "shop.admin.new": "Nytt produkt",
  "shop.admin.create": "Opprett",
  "shop.admin.name": "Navn",
  "shop.admin.category": "Kategori",
  "shop.admin.summary": "Kort beskrivelse",
  "shop.admin.content": "Produktinformasjon",
  "shop.admin.content_hint": "Tom linje mellom avsnitt. **fet tekst** for overskrifter som Applisering:.",
  "shop.admin.video": "Filmlenke",
  "shop.admin.active": "Vises i butikken",
  "shop.admin.hidden": "Skjult",
  "shop.admin.visible": "Vises",
  "shop.admin.blocked.one": "{count} sperret",
  "shop.admin.blocked.other": "{count} sperret",
  "shop.admin.save": "Lagre",
  "shop.admin.saved": "Lagret.",
  "shop.admin.failed": "Kunne ikke lagre. Kontroller feltene og prøv igjen.",
  "shop.admin.back": "Alle produkter",
  "shop.admin.image": "Bilde",
  "shop.admin.upload": "Last opp bilde",
  "shop.admin.upload_hint": "JPEG, PNG eller WebP, maks 3 MB.",
  "shop.admin.variants": "Størrelser",
  "shop.admin.sku": "Art.nr",
  "shop.admin.size": "Størrelse",
  "shop.admin.orderable": "Kan bestilles",
  "shop.admin.add_variant": "Legg til størrelse",
  "shop.admin.settings": "Innstillinger",
  "shop.admin.settings_title": "Butikkinnstillinger",
  "shop.admin.seller": "Avsender på følgeseddelen",
  "shop.admin.seller_hint": "Står øverst på hver følgeseddel. Org.nr og MVA-nr vises når de er fylt ut.",
  "shop.admin.legal_name": "Firmanavn",
  "shop.admin.address": "Adresse",
  "shop.admin.postcode": "Postnummer",
  "shop.admin.city": "Sted",
  "shop.admin.email": "E-post",
  "shop.admin.phone": "Telefon",
  "shop.admin.org_nr": "Org.nr",
  "shop.admin.vat_nr": "MVA-nr",
  "shop.admin.empty": "Ingen produkter samsvarer med søket.",
  "shop.hq_bell.open": "Vis HQ-varsler",
  "shop.hq_bell.title": "Bestillinger fra verksteder",
  "shop.hq_bell.empty": "Ingen nye bestillinger.",
  "shop.hq_bell.kind.shop_order_placed": "Ny bestilling",
  "shop.hq_bell.kind.shop_order_cancelled": "Bestilling avbrutt",
  "shop.hq_bell.body": "{workshop} · ordre {number}",
  "shop.hq_bell.mark_all_read": "Merk alle som lest",
  "shop.hq_bell.see_all": "Vis alle",
  "shop.hq_history.title": "Ordrevarsler",
  "shop.hq_history.unread.one": "{count} ulest",
  "shop.hq_history.unread.other": "{count} uleste",
  "shop.hq_history.all_read": "Alt er lest.",
  "shop.hq_history.unread_only": "Bare uleste",
  "shop.hq_history.empty": "Ingen varsler ennå.",
  "shop.hq_history.empty_filtered": "Ingenting samsvarer med filteret.",
  "shop.hq_history.load_more": "Vis flere",
  "shop.hq_history.error": "Varslene kunne ikke lastes.",
  "shop.email.order_cancelled.subject": "Ordre {number} er avbrutt av HQ",
  "shop.email.order_cancelled.heading": "Bestillingen deres er avbrutt",
  "shop.email.order_cancelled.body": "HQ har avbrutt ordre {number}. Ingenting er sendt.",
  "shop.email.order_closed.subject": "Ordre {number} er ferdig – resten sendes ikke",
  "shop.email.order_closed.heading": "Bestillingen deres er ferdig",
  "shop.email.order_closed.body": "HQ har sendt det som fantes på lager av ordre {number}. Resten sendes ikke, og ordren gjelder nå bare det som er sendt, i henhold til følgesedlene.",
  "shop.email.short_line": "{product}: {qty} av {ordered} sendt",
  "shop.email.tracking": "Sporingsnummer: {tracking}",
  "shop.status.partially_shipped": "Delvis sendt",
  "shop.status.delivered": "Levert",
  "shop.event.partially_shipped": "HQ sendte en del av bestillingen",
  "shop.event.delivered": "Verkstedet har mottatt bestillingen",
  "shop.hq_bell.kind.shop_order_delivered": "Bestilling mottatt",
  "shop.order.shipped_qty": "Sendt",
  "shop.order.shipments": "Leveranser",
  "shop.order.shipment": "Leveranse {number}",
  "shop.order.tracking": "Sporing: {tracking}",
  "shop.order.no_tracking": "Ingen sporingsnummer",
  "shop.order.received": "Bekreft mottatt",
  "shop.order.received_confirm": "Har hele bestillingen kommet frem?",
  "shop.order.received_toast": "Takk! Bestillingen er merket som mottatt.",
  "shop.hq.ship_title": "Send",
  "shop.hq.ship_hint": "Angi hvor mange som sendes nå. Resten kan sendes senere.",
  "shop.hq.tracking": "Sporingsnummer",
  "shop.hq.ship_now": "Send",
  "shop.hq.to_ship": "Å sende",
  "shop.hq.cancel": "Avbryt ordren",
  "shop.hq.cancel_hint": "Ingenting er sendt. Verkstedet ser begrunnelsen.",
  "shop.hq.cancelled_toast": "Ordren er avbrutt.",
  "shop.hq.close": "Avslutt uten resten",
  "shop.hq.close_hint": "Det som ikke er sendt, fjernes fra ordren, og ordren gjelder bare det som er sendt. Verkstedet får en e-post med begrunnelsen.",
  "shop.hq.closed_toast": "Ordren er avsluttet.",
  "shop.cart.delivery": "Leveringsadresse",
  "shop.cart.delivery_workshop": "Verkstedets adresse",
  "shop.cart.delivery_other": "Annen adresse",
  "shop.cart.delivery_incomplete": "Verkstedets adresse er ikke komplett. Oppgi en leveringsadresse.",
  "shop.cart.delivery_name": "Mottaker",
  "shop.cart.delivery_line1": "Gateadresse",
  "shop.cart.delivery_line2": "C/o eller etasje (valgfritt)",
  "shop.cart.delivery_postcode": "Postnummer",
  "shop.cart.delivery_city": "Sted",
  "shop.cart.no_longer_available": "Finnes ikke lenger i butikken og sendes ikke med.",
  "shop.paused": "Verkstedet er satt på pause og kan ikke bestille nå.",
  "shop.email_log.title": "E-post",
  "shop.email_log.empty": "Ingen e-post ennå.",
  "shop.email_log.kind.order_placed": "Ny bestilling til HQ",
  "shop.email_log.kind.order_approved": "Godkjent",
  "shop.email_log.kind.order_rejected": "Avvist",
  "shop.email_log.kind.order_shipped": "Leveranse {number} med følgeseddel",
  "shop.email_log.kind.order_cancelled": "Avbrutt av HQ",
  "shop.email_log.kind.order_closed": "Avsluttet uten resten",
  "shop.email_log.status.pending": "Venter",
  "shop.email_log.status.sent": "Sendt",
  "shop.email_log.status.failed": "Mislyktes",
  "shop.email_log.resend": "Send igjen",
  "shop.email_log.resent": "E-posten sendes igjen.",
  "shop.export.title": "Eksport",
  "shop.export.hint": "Excel-fil (CSV) for valgt periode.",
  "shop.export.from": "Fra",
  "shop.export.to": "Til",
  "shop.export.orders": "Ordrelinjer",
  "shop.export.invoices": "Følgesedler",
  "shop.admin.language": "Språk",
  "shop.admin.translation_hint": "Tomt felt viser den svenske teksten.",
  "shop.admin.categories": "Kategorier",
  "shop.admin.categories_hint": "Navn på alle språk. Tomt felt viser det svenske navnet.",
  "shop.admin.new_category": "Ny kategori",
  "shop.admin.move_up": "Flytt opp",
  "shop.admin.move_down": "Flytt ned",
  "shop.admin.delete": "Fjern",
  "shop.admin.delete_product": "Fjern produktet",
  "shop.admin.delete_confirm": "Fjerne {name}? Det går bare hvis ingen har bestilt det. Ellers, skjul det i stedet.",
  "shop.admin.deleted": "Fjernet.",
  "shop.admin.in_use": "Kan ikke fjernes fordi det er bestilt. Skjul det i stedet.",
  "shop.admin.category_in_use": "Kategorien har produkter og kan ikke fjernes.",
  "shop.analytics.tab": "Butikk",
  "shop.analytics.title": "Butikken i nettverket",
  "shop.analytics.body": "Bestillinger fra verkstedene i valgt periode.",
  "shop.analytics.orders": "Ordrer",
  "shop.analytics.fill_rate": "Leveransgrad",
  "shop.analytics.fill_rate_hint": "Andel av bestilt antall som HQ godkjente.",
  "shop.analytics.approve_time": "Tid til beslutning",
  "shop.analytics.ship_time": "Tid til forsendelse",
  "shop.analytics.deliver_time": "Tid til mottatt",
  "shop.analytics.median": "Median",
  "shop.analytics.hours": "{value} t",
  "shop.analytics.days": "{value} d",
  "shop.analytics.none": "—",
  "shop.analytics.statuses": "Status",
  "shop.analytics.per_day": "Ordrer per dag",
  "shop.analytics.chart_label": "{count} ordrer mellom {from} og {to}",
  "shop.analytics.workshops": "Verksteder",
  "shop.analytics.workshop": "Verksted",
  "shop.analytics.country": "Land",
  "shop.analytics.last_order": "Siste ordre",
  "shop.analytics.no_orders": "Ingen ordrer",
  "shop.analytics.products": "Mest bestilte produkter",
  "shop.analytics.qty": "Antall",
  "shop.analytics.ordered_by": "Verksteder",
  "shop.analytics.empty": "Ingen bestillinger i perioden.",
  "shop.analytics.error": "Tallene kunne ikke lastes.",
  "shop.cart.summary": "Din bestilling",
  "shop.analytics.units": "Godkjente enheter",
  "shop.analytics.delivery_notes": "Følgesedler"
}
